// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"280":"bf6835c6","559":"ba3c1131","621":"289d834a","920":"a6cedc4b"}[chunkId] + ".css";
};